import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 50,
    height: 50,
    backgroundColor: theme.palette.details,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexAlign: 'center',
    flexDirection: 'row',
  },
  bookmarkIcon: {
    fontSize: 20,
    color: theme.palette.primary.main,
  },
  menuBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 1,
    padding: '15px 20px',
    cursor: 'pointer',
    marginLeft: '24px',
    marginRight: '24px',
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper2,
  },
}))

export default useStyles
